import { useEffect, useState } from 'react';

const DEFAULT_BREAKPOINT_PX = 768;

export const useIsMobile = (breakpointPx = DEFAULT_BREAKPOINT_PX) => {
	const query = `(max-width: ${breakpointPx - 1}px)`;
	const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

	useEffect(() => {
		const mql = window.matchMedia(query);
		const onChange = () => setIsMobile(mql.matches);
		onChange();
		mql.addEventListener('change', onChange);
		return () => mql.removeEventListener('change', onChange);
	}, [query]);

	return isMobile;
};
